export default "__VITE_ASSET__9QzJRXAN__"